<template>
    <footer class="footer">
        <nav class="navigation">
            <RouterLink to="/" class="navigation__link">
                <div class="navigation__link-icon">
                    <HomeIcon :is-active="route.name === 'home'" />
                </div>
                <div class="navigation__link-text">Home</div>
            </RouterLink>
            <RouterLink to="/scan" class="navigation__link">
                <div class="navigation__link-icon">
                    <ScanIcon :is-active="route.name === 'scan'" />
                </div>
                <div class="navigation__link-text">Scan</div>
            </RouterLink>
            <RouterLink to="/register" class="navigation__link">
                <div class="navigation__link-icon">
                    <RegisterIcon :is-active="isRegisterActive" />
                </div>
                <div class="navigation__link-text">Register</div>
            </RouterLink>
        </nav>
    </footer>
</template>

<script setup lang="ts">
import HomeIcon from '@/components/icons/homeIcon.vue'
import RegisterIcon from '@/components/icons/registerIcon.vue'
import ScanIcon from '@/components/icons/scanIcon.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const isRegisterActive = computed(() =>
    ['register-scan', 'register-select', 'register-success'].includes(String(route.name))
)
</script>

<style scoped lang="stylus">
.navigation
    padding 8px 36px 16px
    display flex
    align-items center
    justify-content space-around
    &__link
        display flex
        flex-direction column
        align-items center
        text-decoration none
        width 80px
        &-text
            font-size 12px
            line-height 16px
            color var(--app-text-grey-color)
            .router-link-active &
                color var(--app-text-color)
        &-icon
            width 32px
            height 32px
            margin-bottom 5px

.footer
    position fixed
    bottom 0
    left 0
    right 0
    z-index 100
    background-color var(--app-bg-color)
    border-top 1px solid var(--app-border-color)
</style>
